<template lang='pug'>
  v-progress-linear.bionic-loading-bar(v-if='showLoading', :indeterminate='true', color='success')
</template>

<script>
import Http from '../services/http.service';

export default {
  name: 'BionicMetricsLoadingBar',
  components: {},
  mounted() {
    Http.setLoadingBar(this.loading);
  },
  methods: {
    loading(show) {
      this.showLoading = show;
    }
  },
  data() {
    return {showLoading: false};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .bionic-loading-bar {
    z-index: 110;
    position: absolute;
    top: 0;
    left: 0;
    margin: 0;
    max-height: 4px;
    width: 100%;
  }
</style>
